<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex enfinty-header flex-col flex-auto justify-between w-full min-w-0">
    <!-- Header -->
    <div>
        <div
            class="relative flex flex-0 items-center w-full h-14 sm:h-14 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
            <ng-container *ngIf="!isScreenSmall">
                <!-- Logo -->
                <div class="flex items-center mx-2 lg:mr-8">
                    <div class="hidden lg:flex">
                        <img class="dark:hidden h-8 w-auto" src="assets/images/logo/smartpay-logo.svg" />
                        <img class="hidden dark:flex h-8 w-auto" src="assets/images/logo/smartpay-logo.svg" />
                    </div>
                    <h3 class="ml-2 text-3xl sm:text-3xl font-bold text-primary">Central</h3>
                    <!-- <img
                    class="flex lg:hidden w-8"
                    src="assets/images/logo/logo.svg"
                /> -->
                </div>
            </ng-container>
            <!-- Navigation toggle button -->
            <ng-container>
                <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
            </ng-container>

            <div class="flex items-center pl-2 ml-auto ">
                <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                <!-- <search [appearance]="'bar'"></search>
                <shortcuts></shortcuts>
                <messages></messages> -->
                <ng-container >
                <!-- *ngIf="isAuthenticate else noAuth" -->
                    <notifications></notifications>
                    <!-- <button type="button" (click)="openDrawer()"
                    class="rounded-full hover:bg-gray-100 flex justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-6 text-gray-500" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" fit=""
                    height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                    <path stroke-linecap="round" stroke-linejoin="round"
                                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"></path>
                            </svg>
                    </button> -->
                    <user></user>
                </ng-container>
                <ng-template #noAuth>
                    <button (click)="login()" class="inline-flex justify-center px-4 py-2 ml-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"> Sign In</button>
                </ng-template>
            </div>
        </div>
        <div class="flex flex-row flex-automt-4 ml-4 mr-4 mt-4">
            <!-- Navigation -->
             <ng-container >  
                <!-- *ngIf="isAuthenticate" -->
                 <fuse-vertical-navigation class="bg-card dark:bg-gray-900 print:hidden mb-2" [appearance]="'enfinity'"
                 [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="enfinityNavigation"
                 [opened]="!isScreenSmall">
                 
                </fuse-vertical-navigation>
            </ng-container>

            <!-- Content -->
            <div class="flex flex-auto w-full mb-2 overflow-hidden">
                <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
                <router-outlet *ngIf="true"></router-outlet>
            </div>
        </div>
    </div>
    <!-- Footer -->
    <!-- <div
        class="relative flex flex-0 items-center w-full h-14 sm:h-20 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
    </div> -->
</div>